import { render, staticRenderFns } from "./FairList.vue?vue&type=template&id=55752e44"
import script from "./FairList.vue?vue&type=script&lang=js"
export * from "./FairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports